var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"modal__img",attrs:{"src":_vm.srcAstronavt,"srcset":_vm.srcsetAstronavt,"alt":"sent","rel":"preload"}}),_vm._v(" "),_c('div',{staticClass:"modal__title"},[_vm._v("We sent you an email to confirm")])])}
var staticRenderFns = []

export { render, staticRenderFns }